(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bls-about-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function go(slider, i) {
    var slides = slider.querySelectorAll('[data-bls-ai-slide]');
    var dots = slider.querySelectorAll('[data-bls-ai-dot]');
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    slider._i = i;
  }
  function start(root) {
    (root || document).querySelectorAll('[data-bls-ai-slider]').forEach(function (sl) {
      if (sl._t) clearInterval(sl._t);
      sl._i = 0;
      if (sl.querySelectorAll('[data-bls-ai-slide]').length > 1) sl._t = setInterval(function () { go(sl, (sl._i || 0) + 1); }, 4500);
    });
  }
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-bls-ai-dot]');
    if (!d) return;
    var sl = d.closest('[data-bls-ai-slider]');
    go(sl, Number(d.dataset.blsAiDot));
    if (sl._t) { clearInterval(sl._t); sl._t = setInterval(function () { go(sl, (sl._i || 0) + 1); }, 4500); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-about-pillars"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pick(item) {
    var root = item.closest('[data-bls-ap]');
    var i = item.dataset.blsApItem;
    root.querySelectorAll('[data-bls-ap-item]').forEach(function (b) { b.classList.toggle('is-active', b === item); });
    root.querySelectorAll('[data-bls-ap-img]').forEach(function (m) { m.classList.toggle('is-active', m.dataset.blsApImg === i); });
  }
  document.addEventListener('click', function (e) { var it = e.target.closest('[data-bls-ap-item]'); if (it) pick(it); });
  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var it = e.target.closest('[data-bls-ap-item]'); if (it && !it.classList.contains('is-active')) pick(it);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-cart-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsCartPage) return;
  window.__blsCartPage = true;

  function pages() { return Array.prototype.slice.call(document.querySelectorAll('[data-bls-cartpage]')); }

  /* Les boutons +/−/Retirer portent data-bls-qty : bureaulift-site.js appelle BLSCart.change(), met à jour le tiroir
     puis émet bls:cart-updated. Ici on grise la page pendant la requête, puis on recharge la section. */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-bls-qty]');
    if (!q) return;
    var page = q.closest('[data-bls-cartpage]');
    if (page) page.classList.add('is-busy');
  }, true);

  function reload(page) {
    var id = page.dataset.sectionId;
    if (!id) { location.reload(); return; }
    return fetch(location.pathname + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data && data[id] ? data[id] : '';
        var fresh = tmp.querySelector('[data-bls-cartpage-inner]');
        var cur = page.querySelector('[data-bls-cartpage-inner]');
        if (fresh && cur) cur.replaceWith(fresh); else location.reload();
      })
      .catch(function () { location.reload(); })
      .then(function () { page.classList.remove('is-busy'); });
  }
  document.addEventListener('bls:cart-updated', function () { pages().forEach(reload); });

  /* Code promo : lien de réduction Shopify /discount/CODE, retour sur le panier */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bls-cartpage-code]');
    if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input[name="code"]').value || '').trim();
    var msg = f.parentNode.querySelector('[data-bls-cartpage-msg]');
    if (!code) { if (msg) msg.hidden = true; return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var back = location.pathname + '?code=' + encodeURIComponent(code);
    location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });

  /* Retour du lien de réduction : message « appliqué » ou « non valable » */
  function codeMessage() {
    var code;
    try { code = new URLSearchParams(location.search).get('code'); } catch (err) { return; }
    if (!code) return;
    pages().forEach(function (page) {
      var f = page.querySelector('[data-bls-cartpage-code]');
      var msg = page.querySelector('[data-bls-cartpage-msg]');
      if (!f || !msg) return;
      var applied = (f.dataset.codes || '').toUpperCase().split('|').indexOf(code.toUpperCase()) > -1;
      msg.textContent = applied ? 'Code appliqué.' : 'Ce code n’est pas valide pour ce panier.';
      msg.classList.toggle('is-ok', applied);
      msg.hidden = false;
      if (!applied) f.querySelector('input[name="code"]').value = code;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', codeMessage); else codeMessage();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-coll-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsCollGrid) return;
  window.__blsCollGrid = true;
  function items(sec) { return Array.prototype.slice.call(sec.querySelectorAll('[data-bls-cg-grid] > [data-bls-cat]')); }
  function updateCount(sec) {
    var n = items(sec).filter(function (i) { return !i.classList.contains('is-hidden'); }).length;
    var els = Array.prototype.slice.call(sec.querySelectorAll('[data-bls-coll-count]'));
    /* Le compteur du hero de collection suit la première grille de la page */
    var first = document.querySelector('[data-bls-cg]');
    if (first === sec) {
      Array.prototype.slice.call(document.querySelectorAll('.bls-coll-hero [data-bls-coll-count]')).forEach(function (el) { els.push(el); });
    }
    els.forEach(function (el) { el.textContent = (el.getAttribute('data-tpl') || '[n]').replace('[n]', n); });
  }
  function applyFilter(sec, val) {
    val = (val || 'all').toLowerCase();
    Array.prototype.slice.call(sec.querySelectorAll('[data-bls-cg-filter]')).forEach(function (b) {
      var on = b.getAttribute('data-bls-cg-filter') === val;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    items(sec).forEach(function (i) {
      var cats = (i.getAttribute('data-bls-cat') || '').split(/\s+/);
      i.classList.toggle('is-hidden', !(val === 'all' || cats.indexOf(val) > -1));
    });
    updateCount(sec);
  }
  function applySort(sec, mode) {
    var grid = sec.querySelector('[data-bls-cg-grid]');
    if (!grid) return;
    var kids = Array.prototype.slice.call(grid.children);
    kids.sort(function (a, b) {
      var ia = +a.getAttribute('data-index') || 0, ib = +b.getAttribute('data-index') || 0;
      if (mode === 'asc' || mode === 'desc') {
        var ca = a.hasAttribute('data-prix'), cb = b.hasAttribute('data-prix');
        if (ca && cb) {
          var d = (+a.getAttribute('data-prix')) - (+b.getAttribute('data-prix'));
          if (d) return mode === 'asc' ? d : -d;
        } else if (ca !== cb) return ca ? -1 : 1;
      }
      return ia - ib;
    });
    kids.forEach(function (k) { grid.appendChild(k); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bls-cg-filter]');
    if (!b) return;
    var sec = b.closest('[data-bls-cg]');
    if (sec) applyFilter(sec, b.getAttribute('data-bls-cg-filter'));
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-bls-cg-sort]');
    if (!s) return;
    var sec = s.closest('[data-bls-cg]');
    if (sec) applySort(sec, s.value);
  });
  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-bls-cg]')).forEach(function (sec) {
      var h = (window.location.hash || '').replace('#', '').toLowerCase();
      var btn = h && sec.querySelector('[data-bls-cg-filter="' + h.replace(/"/g, '') + '"]');
      if (btn) applyFilter(sec, h); else updateCount(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  window.addEventListener('hashchange', function () { init(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-coll-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsCollHero) return;
  window.__blsCollHero = true;
  /* Liens d'ancre du hero (#cadres, #choisir, #prevenir) : défilement doux sous l'en-tête collant */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.bls-coll-hero a[href*="#"]');
    if (!a || a.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
    var id = decodeURIComponent(a.hash.slice(1));
    var el = id && document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    window.scrollTo({ top: window.scrollY + el.getBoundingClientRect().top - 90, behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEL = '[data-bls-cf] input[name="contact[sujet]"]';
  function apply(radio) {
    var form = radio.closest('[data-bls-cf]');
    if (!form) return;
    var hint = form.querySelector('[data-bls-cf-hint]');
    var box = form.querySelector('[data-bls-cf-hintbox]');
    if (hint) hint.textContent = radio.getAttribute('data-hint') || '';
    if (box) box.hidden = !radio.getAttribute('data-hint');
    var msg = form.querySelector('[data-bls-cf-msg]');
    if (msg && radio.getAttribute('data-ph')) msg.placeholder = radio.getAttribute('data-ph');
    var f = radio.getAttribute('data-fields');
    Array.prototype.forEach.call(form.querySelectorAll('[data-bls-cf-field]'), function (el) {
      var on = el.getAttribute('data-bls-cf-field') === f;
      el.hidden = !on;
      var i = el.querySelector('input');
      if (i) i.disabled = !on;
    });
  }
  function fromHash() {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (r) {
      if (r.getAttribute('data-key') && r.getAttribute('data-key') === h) { r.checked = true; apply(r); }
    });
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL + ':checked'), apply);
    fromHash();
  }
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest(SEL);
    if (r) apply(r);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bls-cf-again]');
    if (!b) return;
    var form = b.closest('[data-bls-cf]');
    if (!form) return;
    e.preventDefault();
    form.querySelector('[data-bls-cf-ok]').hidden = true;
    form.querySelector('[data-bls-cf-fields]').hidden = false;
  });
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-faq-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  var $all = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  function sec() { return document.querySelector('[data-bls-faq]'); }
  function render(s) {
    var st = s.__blsFaq || (s.__blsFaq = { cat: 'all', q: '' });
    var raw = st.q.trim(), q = norm(raw), searching = q.length > 0, n = 0;
    $all('[data-bls-faq-item]', s).forEach(function (it) {
      var txt = (it.querySelector('.bls-faq-list__q') || {}).textContent + ' ' + (it.querySelector('.bls-faq-list__a') || {}).textContent;
      var show = searching ? norm(txt).indexOf(q) !== -1 : (st.cat === 'all' || it.getAttribute('data-cat') === st.cat);
      it.hidden = !show;
      if (show) n++;
    });
    var label = '';
    $all('[data-bls-faq-cat]', s).forEach(function (c) {
      var on = !searching && c.getAttribute('data-bls-faq-cat') === st.cat;
      c.classList.toggle('is-on', on);
      if (on) label = c.getAttribute('data-label');
    });
    s.classList.toggle('is-cat', !searching && st.cat !== 'all');
    var t = s.querySelector('[data-bls-faq-title]');
    if (t) t.textContent = searching ? s.getAttribute('data-res') + ' « ' + raw + ' »' : (st.cat === 'all' ? s.getAttribute('data-all-title') : label);
    var c = s.querySelector('[data-bls-faq-count]');
    if (c) c.textContent = n + ' ' + (n > 1 ? s.getAttribute('data-many') : s.getAttribute('data-one'));
    var e = s.querySelector('[data-bls-faq-empty]');
    if (e) e.hidden = n > 0;
    $all('[data-bls-faq-clear]').forEach(function (b) { b.hidden = !searching; });
  }
  function closeAll(s) {
    $all('[data-bls-faq-item].is-open', s).forEach(function (it) {
      it.classList.remove('is-open');
      var b = it.querySelector('[data-bls-acc-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function setCat(s, cat) {
    var st = s.__blsFaq || (s.__blsFaq = { cat: 'all', q: '' });
    st.cat = cat; st.q = '';
    $all('[data-bls-faq-search]').forEach(function (i) { i.value = ''; });
    closeAll(s);
    render(s);
  }
  function fromHash() {
    var s = sec();
    if (!s) return;
    var h = norm(decodeURIComponent((location.hash || '').replace('#', '')));
    if (!h) return;
    var hit = null, alias = false;
    $all('[data-bls-faq-cat]', s).forEach(function (c) {
      if (hit) return;
      if (c.getAttribute('data-bls-faq-cat') === h) hit = c;
      else if ((c.getAttribute('data-alias') || '').split(',').indexOf(h) !== -1) { hit = c; alias = true; }
    });
    if (!hit) return;
    setCat(s, hit.getAttribute('data-bls-faq-cat'));
    if (alias) hit.scrollIntoView({ block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-bls-faq-cat]');
    if (c) { setCat(c.closest('[data-bls-faq]'), c.getAttribute('data-bls-faq-cat')); return; }
    var x = e.target.closest && e.target.closest('[data-bls-faq-clear]');
    if (x) {
      var s = sec();
      $all('[data-bls-faq-search]').forEach(function (i) { i.value = ''; });
      if (s) { (s.__blsFaq || (s.__blsFaq = { cat: 'all', q: '' })).q = ''; render(s); }
    }
  });
  document.addEventListener('input', function (e) {
    var i = e.target.closest && e.target.closest('[data-bls-faq-search]');
    if (!i) return;
    var s = sec();
    if (!s) return;
    (s.__blsFaq || (s.__blsFaq = { cat: 'all', q: '' })).q = i.value;
    closeAll(s);
    render(s);
  });
  function init() { var s = sec(); if (s) { render(s); fromHash(); } }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsHomeHero) return;
  window.__blsHomeHero = true;
  var DELAY = 4500;
  function go(el, i) {
    var slides = el.querySelectorAll('[data-slide]');
    var dots = el.querySelectorAll('[data-bls-home-dot]');
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    el.dataset.index = i;
    Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle('is-active', k === i); });
    Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  function start(el) {
    if (el.__blsTimer) clearInterval(el.__blsTimer);
    if (el.querySelectorAll('[data-slide]').length < 2) return;
    el.__blsTimer = setInterval(function () {
      if (!document.body.contains(el)) { clearInterval(el.__blsTimer); return; }
      go(el, (Number(el.dataset.index) || 0) + 1);
    }, DELAY);
  }
  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-bls-home-slides]'), start);
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-bls-home-dot]');
    if (dot) {
      var el = dot.closest('[data-bls-home-slides]');
      go(el, Number(dot.dataset.blsHomeDot) || 0);
      start(el);
      return;
    }
    var link = e.target.closest('[data-bls-home-hero-scroll]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-bls-home-slides]'), function (el) { clearInterval(el.__blsTimer); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    if (!slide) return;
    var el = slide.closest('[data-bls-home-slides]');
    var idx = Array.prototype.indexOf.call(el.querySelectorAll('[data-slide]'), slide);
    clearInterval(el.__blsTimer);
    go(el, idx);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-home-motors"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsHomeMotors) return;
  window.__blsHomeMotors = true;
  function select(box, i) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-bls-home-motors-tab]'), function (t, k) {
      t.classList.toggle('is-active', k === i);
      t.setAttribute('aria-selected', String(k === i));
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-bls-home-motors-panel]'), function (p, k) { p.hidden = k !== i; });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-bls-home-motors-tab]');
    if (!tab) return;
    select(tab.closest('[data-bls-home-motors]'), Number(tab.dataset.blsHomeMotorsTab) || 0);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-bls-home-motors-panel]');
    if (!panel) return;
    var box = panel.closest('[data-bls-home-motors]');
    select(box, Array.prototype.indexOf.call(box.querySelectorAll('[data-bls-home-motors-panel]'), panel));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-home-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function lb(el) { return el.closest('.bls-home-reviews').querySelector('[data-bls-rev-lb]'); }
  function open(card) {
    var box = lb(card);
    box.querySelector('[data-bls-rev-img]').src = card.dataset.src;
    box.querySelector('[data-bls-rev-img]').alt = card.dataset.alt || '';
    var txt = card.querySelector('.bls-home-reviews__txt');
    box.querySelector('[data-bls-rev-cap]').innerHTML = txt ? txt.innerHTML : '';
    box.hidden = false;
    document.documentElement.classList.add('bls-lock');
  }
  function close(box) { box.hidden = true; box.querySelector('[data-bls-rev-img]').src = ''; document.documentElement.classList.remove('bls-lock'); }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-bls-rev-open]');
    if (card) { open(card); return; }
    var box = e.target.closest('[data-bls-rev-lb]');
    if (box && (e.target === box || e.target.closest('[data-bls-rev-close]'))) close(box);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { document.querySelectorAll('[data-bls-rev-lb]:not([hidden])').forEach(close); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-bls-rev-open]')) { e.preventDefault(); open(e.target); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-home-why"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__blsHomeWhy) return;
  window.__blsHomeWhy = true;
  var layer = null;
  var opener = null;
  function close() {
    if (!layer) return;
    layer.remove();
    layer = null;
    document.documentElement.classList.remove('bls-lock');
    if (opener && document.body.contains(opener)) opener.focus();
    opener = null;
  }
  function open(btn) {
    var tpl = btn.parentNode.querySelector('[data-bls-home-why-tpl]');
    if (!tpl) return;
    close();
    opener = btn;
    layer = document.createElement('div');
    layer.className = 'bl bls-home-why__layer';
    layer.appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(layer);
    document.documentElement.classList.add('bls-lock');
    var x = layer.querySelector('[data-bls-home-why-close]');
    if (x) x.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bls-home-why-open]');
    if (btn) { open(btn); return; }
    if (!layer) return;
    if (e.target.closest('[data-bls-home-why-close]') || e.target === layer) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('shopify:section:unload', close);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-page-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Pastille « En ligne / Hors ligne » : heure de Paris, jours et horaires réglés dans la section */
  function update(root) {
    var els = (root || document).querySelectorAll('[data-bls-status]');
    if (!els.length) return;
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })); } catch (e) { now = new Date(); }
    var d = now.getDay(), h = now.getHours();
    Array.prototype.forEach.call(els, function (el) {
      var days = (el.getAttribute('data-days') || '1-6').split('-');
      var d0 = Number(days[0]), d1 = Number(days[1]);
      var from = Number(el.getAttribute('data-from')), to = Number(el.getAttribute('data-to'));
      var open = d >= d0 && d <= d1 && h >= from && h < to;
      el.classList.toggle('is-online', open);
      var lab = el.querySelector('[data-bls-status-label]');
      if (lab) lab.textContent = open ? el.getAttribute('data-open') : el.getAttribute('data-closed');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { update(); }); else update();
  document.addEventListener('shopify:section:load', function (e) { update(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-track-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-bls-track]');
    if (!f) return;
    e.preventDefault();
    var target = f.getAttribute('data-target') || '/account';
    if (f.getAttribute('data-ext') !== 'true') { window.location.href = target; return; }
    var order = (f.querySelector('[data-bls-track-order]').value || '').trim();
    var email = (f.querySelector('[data-bls-track-email]').value || '').trim();
    var sep = target.indexOf('?') === -1 ? '?' : '&';
    window.location.href = target + sep + encodeURIComponent(f.getAttribute('data-po') || 'order') + '=' + encodeURIComponent(order) + '&' + encodeURIComponent(f.getAttribute('data-pe') || 'email') + '=' + encodeURIComponent(email);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
